import { useEffect, useState } from 'react';

export function useIsMobile(maxWidth = 768): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(`(max-width: ${maxWidth}px)`);

    const onChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    setIsMobile(mql.matches);

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    } else {
      const legacyHandler = (e: any) => setIsMobile(e.matches);
      // @ts-ignore legacy browsers
      mql.addListener(legacyHandler);
      // @ts-ignore legacy browsers
      return () => mql.removeListener(legacyHandler);
    }
  }, [maxWidth]);

  return isMobile;
}
